


































import { Component, Vue, Watch } from 'vue-property-decorator';
import TitleMixin from '@/mixins/title-mixin';
import SecondaryNav from '@/components/navbars/secondary-nav.vue';
import EscalatedAlertTableTab from './components/escalated-alert-table-tab.vue';
import EscalatedAlertCard from './components/escalated-alert-card.vue';
import { EscalatedAlert, EscalatedAlertStatus } from '@/api';
import { EscalatedAlertApiService } from '@/services/escalated-alert-service';
import { navigateTo } from '@/common/RouteUtils';

@Component({
	components: {
		SecondaryNav,
		EscalatedAlertCard,
		EscalatedAlertTableTab,
	},
	mixins: [TitleMixin],
})
export default class EscalatedAlertList extends Vue {
	public tableReRenderer = 0;
	public alert: EscalatedAlert | null = null;
	public loadingAlert = false;
	public detailsLoaded = false;
	public alertError = '';
	private readonly alertApi = new EscalatedAlertApiService();

	public get pageStatus(): EscalatedAlertStatus {
		return this.$route.meta.alertStatus || EscalatedAlertStatus.New;
	}

	public get alertId(): string | undefined {
		return this.$route.meta.alertPanel ? String(this.$route.params.alertId) : undefined;
	}

	public get idState(): boolean {
		return !!this.alertId;
	}

	public pageTitle() {
		return 'Levno | Escalated Alerts';
	}

	public setAlert(alert: EscalatedAlert | null): void {
		if (!alert || String(alert.id) === this.alertId) {
			if (this.alertId) navigateTo(this.$router, { name: `escalatedAlerts.${this.pageStatus}` });
			return;
		}
		this.detailsLoaded = false;
		this.alert = alert;
		const panel = alert.status === EscalatedAlertStatus.Resolved ? 'history' : 'graph';
		navigateTo(this.$router, {
			name: `escalatedAlerts.${this.pageStatus}.${panel}`,
			params: { alertId: String(alert.id) },
		});
	}

	@Watch('alertId', { immediate: true })
	public async restoreAlert(): Promise<void> {
		const id = this.alertId;
		if (!id) {
			this.alert = null;
			this.detailsLoaded = false;
			this.loadingAlert = false;
			return;
		}
		if (String(this.alert?.id) === id) return;
		this.alert = null;
		this.detailsLoaded = false;
		this.alertError = '';
		this.loadingAlert = true;
		const { escalatedAlert, errorMessage } = await this.alertApi.getEscalatedAlertById(Number(id), {
			params: { include: 'logs.user, event, entity, product, product.users' },
		});
		if (this.alertId !== id) return;
		this.detailsLoaded = !!escalatedAlert;
		this.alert = escalatedAlert || null;
		this.alertError = errorMessage || 'Alert not found.';
		this.loadingAlert = false;
	}

	public rerender(): void {
		this.tableReRenderer++;
		this.setAlert(null);
	}
}
